/* Renew - House Lights. Ported from the concept: sticky nav state, the
   scroll reveal, the mobile drawer and the FAQ height animation. */
/* The nav rides transparent over the reveal, then takes on its surface.
   Fail-safe: if this never runs the bar is simply transparent over a dark page. */
(function(){
  var nav=document.querySelector('nav.topnav');
  if(!nav)return;
  var sync=function(){nav.classList.toggle('stuck',window.scrollY>40);};
  sync();
  window.addEventListener('scroll',sync,{passive:true});
})();

/* ── FAQ: the panel opens and shuts instead of jumping ─────────────
   <details> has no animatable state of its own, so the answer box is driven
   directly. The element stays open for the whole closing run and only reverts
   at the end, which is what lets the height ease back down rather than vanish.
   Built on the Web Animations API so a click mid-flight reverses cleanly from
   wherever it got to. Reduced motion keeps the native instant toggle - the
   state change still reads, it just doesn't travel. */
(function () {
  var faq = document.querySelector('.faq');
  if (!faq || !document.body.animate) return;          // no WAAPI: native toggle
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches) return;
  faq.classList.add('smooth');

  [].forEach.call(faq.querySelectorAll('details'), function (d) {
    var summary = d.querySelector('summary');
    var panel = d.querySelector('.ans');
    if (!summary || !panel) return;
    var anim = null;

    function run(opening) {
      /* Measure the live height BEFORE cancelling, so a click mid-flight
         resumes from where it actually is rather than snapping to an end. */
      var current = anim ? panel.getBoundingClientRect().height : null;
      if (anim) { anim.cancel(); anim = null; }

      if (opening) d.open = true;
      d.classList.toggle('is-open', opening);

      var to = 0;
      if (opening) {
        panel.style.height = 'auto';
        to = panel.getBoundingClientRect().height;
      }
      /* A closed <details> still reports its child's laid-out height, so the
         start point is asserted rather than measured - measuring it produced a
         from == to no-op and the panel simply appeared. */
      var from = current !== null ? current
               : (opening ? 0 : panel.getBoundingClientRect().height);
      panel.style.height = from + 'px';

      panel.style.willChange = 'height';
      anim = panel.animate(
        { height: [from + 'px', to + 'px'], opacity: [opening ? 0 : 1, opening ? 1 : 0] },
        /* exits run shorter than entrances so dismissing never feels like waiting */
        { duration: opening ? 340 : 240, easing: 'cubic-bezier(.16,1,.3,1)' }
      );
      anim.onfinish = function () {
        anim = null;
        panel.style.willChange = '';
        panel.style.height = opening ? 'auto' : '';
        if (!opening) d.open = false;
      };
    }

    summary.addEventListener('click', function (e) {
      e.preventDefault();                               // we own the state change
      run(!d.classList.contains('is-open'));
    });
  });
})();

/* mobile nav toggle */
(function(){
  var b=document.getElementById('burger'),m=document.getElementById('menu');
  if(!b||!m)return;
  b.addEventListener('click',function(){
    var open=m.classList.toggle('open');
    b.setAttribute('aria-expanded',open?'true':'false');
    b.setAttribute('aria-label',open?'Close menu':'Open menu');
  });
  m.addEventListener('click',function(e){
    if(e.target.closest('a')){m.classList.remove('open');b.setAttribute('aria-expanded','false');b.setAttribute('aria-label','Open menu');}
  });
})();

/* Scroll reveal, fail-safe. Copied verbatim from the concept template. */
(function () {
  var els = [].slice.call(document.querySelectorAll('.rise'));
  if (!els.length) return;
  var show = function (el) { el.classList.add('in'); };

  if (!('IntersectionObserver' in window)) { els.forEach(show); return; }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
    });
  }, { threshold: 0, rootMargin: '0px 0px 15%' });

  els.forEach(function (el) {
    /* Stagger by position among its own siblings, not by a running page index -
       a global counter made the six claim cards arrive in an arbitrary order.
       Capped so a long group never turns into a queue. */
    var group = [].filter.call(el.parentNode.children, function (n) {
      return n.classList && n.classList.contains('rise');
    });
    el.style.transitionDelay = Math.min(group.indexOf(el), 4) * 60 + 'ms';
    io.observe(el);
  });

  setTimeout(function () {
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight * 1.2) show(el);
    });
  }, 1200);
})();

/* ── CART DRAWER ─────────────────────────────────────────────────
   Opens from the right, and keeps itself honest by re-rendering from the
   server (Section Rendering API) after every change rather than patching the
   DOM by hand - so what you see is always what the cart actually holds.

   Enhancement only. With script off, the nav icon is a link to /cart and the
   add-to-cart forms post normally; nothing here is needed to buy anything. */
(function () {
  var root = document.getElementById('cart-drawer');
  if (!root || !window.fetch) return;

  var opener = null;   // what to hand focus back to on close

  function count(n) {
    [].forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
      if (el.hasAttribute('data-cart-count') && el.tagName !== 'DIV') {
        el.textContent = n;
        el.classList.toggle('on', n > 0);
      }
    });
    root.setAttribute('data-cart-count', n);
  }

  function open(trigger) {
    opener = trigger || null;
    root.classList.add('open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-lock');
    var focusable = root.querySelector('.drawer-x');
    if (focusable) focusable.focus();
  }

  function close() {
    root.classList.remove('open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-lock');
    if (opener && document.contains(opener)) opener.focus();
    opener = null;
  }

  /* pull the drawer's own markup back from the server and swap it in */
  function refresh(thenOpen, trigger) {
    /* no-store: a cached response here would show a stale cart straight after
       the visitor added something, which is worse than a slow one */
    /* no-store alone is not enough - the edge caches this URL, so the request
       carries a unique parameter too. A stale drawer right after adding
       something is worse than a slightly slower one. */
    var url = window.Shopify.routes.root + '?sections=cart-drawer&_=' + Date.now();
    return fetch(url, { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-drawer');
        if (!fresh) return;
        var wasOpen = root.classList.contains('open');
        root.innerHTML = fresh.innerHTML;
        count(parseInt(fresh.getAttribute('data-cart-count'), 10) || 0);
        if (thenOpen || wasOpen) open(trigger || opener);
      });
  }

  function setQuantity(line, quantity, inDrawer) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST', cache: 'no-store',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () {
      if (inDrawer) return refresh(false);
      window.location.reload();
    });
  }

  /* one listener for the whole drawer, so re-rendered markup keeps working */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open]');
    if (openBtn) { e.preventDefault(); open(openBtn); return; }

    /* The scrim and the X only close. A closer that is a real link - the empty
       cart's "See the products" - has somewhere to go, so close the drawer but
       let the browser follow the href. */
    var closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) {
      if (!closeBtn.hasAttribute('href')) e.preventDefault();
      close();
      return;
    }

    var qty = e.target.closest('[data-qty]');
    if (qty) {
      e.preventDefault();
      qty.disabled = true;
      /* The same line markup is used on the cart page, where there is no drawer
         to re-render - that page reloads instead. Scoping this to the drawer is
         what left the buttons dead on /cart. */
      setQuantity(qty.getAttribute('data-line'), qty.getAttribute('data-qty'), root.contains(qty));
    }
  });

  /* add to cart without losing the page */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', cache: 'no-store', body: new FormData(form) })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        /* A rejected add still resolves - stock ran out, a limit was hit. Saying
           nothing would look like a dead button, so the reason is shown. */
        if (!res.ok) {
          return refresh(true, btn).then(function () {
            var slot = root.querySelector('[data-cart-error]');
            if (slot) {
              slot.textContent = res.data.description || res.data.message || 'That could not be added.';
              slot.hidden = false;
            }
          });
        }
        return refresh(true, btn);
      })
      .catch(function () { form.submit(); })      // network died: let the real post handle it
      .then(function () { if (btn) btn.disabled = false; });
  });


  /* a typed quantity applies when the field is left or Enter is pressed */
  document.addEventListener('change', function (e) {
    var field = e.target.closest('[data-qty-input]');
    if (!field) return;
    var n = parseInt(field.value, 10);
    if (isNaN(n) || n < 0) { n = 0; }
    field.disabled = true;
    setQuantity(field.getAttribute('data-line'), n, root.contains(field));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var field = e.target.closest('[data-qty-input]');
    if (!field) return;
    e.preventDefault();          // never submit the cart page's form by accident
    field.blur();                // which fires change, above
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('open')) close();
  });

  count(parseInt(root.getAttribute('data-cart-count'), 10) || 0);
})();

/* ── CART EXTRAS: note and discount code ─────────────────────────
   Both live in the drawer. The note saves as you stop typing; a code is applied
   through Shopify's own /discount/ route, the same mechanism a shared discount
   link uses, so there is no private API involved. */
(function () {
  if (!window.fetch) return;
  var timer = null;

  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(timer);
    /* wait for a pause rather than posting on every keystroke */
    timer = setTimeout(function () {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST', cache: 'no-store',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 600);
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-discount-apply]')) return;
    var field = document.querySelector('[data-discount-code]');
    var code = field && field.value.trim();
    if (!code) { if (field) field.focus(); return; }
    /* Shopify sets the code on the cart, then sends us back to where we were */
    var back = window.location.pathname + window.location.search;
    window.location.href = window.Shopify.routes.root + 'discount/' +
      encodeURIComponent(code) + '?redirect=' + encodeURIComponent(back);
  });
})();
